"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
var _default = {
  'social-facebook': 'd',
  'social-pinterest': 'P',
  'social-tumblr': 'T',
  'social-twitter': 'e',
  'social-spotify': 'S',
  'social-foursquare': 'U',
  'social-instagram': 'm',
  'social-linkedin': 'a',
  'fast-forward-10': 'a',
  'social-reddit': 'l',
  'social-gplus': 'c',
  'rss': 'W',
  'calendar': 'Z',
  'stop': 'B',
  'pause': 'I',
  'circle': 'f',
  'volume-off': 's',
  'volume-low': 'w',
  'volume-full': 'x',
  'volume-mute': 'b',
  'info': 'K',
  'key': 'Q',
  'closed-captioning': 'u',
  'rewind': 'z',
  'mail': 'v',
  'mail-outline': 'K',
  'search': 'n',
  'down-open-mini': 'k',
  'left-open-big': 'E',
  'right-open-big': 'D',
  'warning': 'C',
  'share': 'F',
  'link': 'G',
  'notification': 'h',
  'profile': 'j',
  'profile-female': 'J',
  'menu': 'r',
  'full-screen-exit': 'o',
  'full-screen': 'O',
  'play': 'H',
  'embed': 'g',
  'speech-bubble': 'i',
  'check-mark': '2',
  'youtube-dark': 'p',
  'cancel': 'q',
  'add': 'V',
  'remove': 'R',
  'keyboard': 'f'
};
exports["default"] = _default;